// Generated by CoffeeScript 2.7.0
var ToggleNavMenuAction;

export default ToggleNavMenuAction = {
  __toggleNavMenu: function() {
    var responses_table_header, responses_table_simple_header, simple_toggle_icon, toggle_icon;
    responses_table_header = DomMaster.find('#js_responses_header');
    responses_table_simple_header = DomMaster.find('#js_responses_simple_header');
    toggle_icon = DomMaster.find('.js_responses_header_toggle_icon');
    simple_toggle_icon = DomMaster.find('.js_responses_simple_header_toggle_icon');
    this.____setHeaderDisplay(responses_table_header, responses_table_simple_header);
    if (!simple_toggle_icon.node || !toggle_icon.node) {
      return;
    }
    simple_toggle_icon.node.proxy('click', () => {
      localStorage.setItem('simple_nav_show', false);
      return this.____setHeaderDisplay(responses_table_header, responses_table_simple_header);
    });
    return toggle_icon.node.proxy('click', () => {
      localStorage.setItem('simple_nav_show', true);
      return this.____setHeaderDisplay(responses_table_header, responses_table_simple_header);
    });
  },
  ____setHeaderDisplay: function(header, simple_header) {
    var simple_nav_show;
    simple_nav_show = localStorage.getItem('simple_nav_show');
    header.node.style.display = simple_nav_show === 'true' ? 'none' : 'block';
    return simple_header.node.style.display = simple_nav_show === 'true' ? 'block' : 'none';
  }
};
